"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSliderFieldLogic = exports.migrateNumberSliderToNumberField = void 0;
var number_slider_migrations_1 = require("./number-slider.migrations");
Object.defineProperty(exports, "migrateNumberSliderToNumberField", { enumerable: true, get: function () { return number_slider_migrations_1.migrateNumberSliderToNumberField; } });
var number_slider_fieldtype_1 = require("./number-slider.fieldtype");
Object.defineProperty(exports, "NumberSliderFieldLogic", { enumerable: true, get: function () { return number_slider_fieldtype_1.NumberSliderFieldLogic; } });
